import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AppStore, AppDispatch } from '../../../store';
import { MaintenanceTable } from '../../DataTable/DataTable';
import { EDataTableType, EModuleType, EApiType } from '../../../data/Constants';
import { joinSelectedKeys } from '../../../services/DataHelperFunctions';
import {
  getApiKeys,
  deleteApiKeys,
  getPrivileges,
  getConfigitPropertyList,
  getPdmPropertyList,
  getServiceUsers,
} from '../../../store/states/ApiKeySlice';
import { setAlertMessage } from '../../../store/states/AlertMessageSlice';
import { useApiError } from '../../../hooks';

import type { IManagementProps } from '../../../../types';

export const ApiKeyManagement = (props: IManagementProps) => {
  const { t } = useTranslation();

  const dispatch = useDispatch<AppDispatch>();
  const errorElement = useApiError(EApiType.PropertyKey);

  useEffect(() => {
    dispatch(getServiceUsers());
    dispatch(getConfigitPropertyList());
    dispatch(getPdmPropertyList());
    dispatch(getPrivileges());
  }, []);

  //Show the error message if api returns any  error
  if (errorElement) return errorElement;

  const deleteItems = (req: string[], keysSelected: string[]) => {
    const apikeys = AppStore.getState().administration.apikeys;
    dispatch(deleteApiKeys({ request: { ids: req } })).then((res) => {
      const delKeys = joinSelectedKeys(keysSelected);
      if (res.payload && typeof res.payload === 'object' && 'data' in res.payload) {
        const message = t('messages.success.delete.apikeys', { length: req.length, list: delKeys });
        dispatch(setAlertMessage({ show: true, message: message, type: 'success' }));
        dispatch(
          getApiKeys({
            token: props.token,
            page: apikeys.currentPage,
            limit: apikeys.recordsPerPage,
            searchCode: apikeys.searchKey,
          })
        );
      } else {
        const message = t('messages.fail.delete.apikeys', { length: req.length, list: delKeys });
        dispatch(setAlertMessage({ show: true, message: message, type: 'error' }));
      }
    });
  };

  return (
    <>
      <h3 className="mainHeader"> {t('labels.apiKeyManagement')} </h3>
      <MaintenanceTable
        token={props.token}
        type={EDataTableType.ApiKeys}
        getDataList={getApiKeys}
        moduleType={EModuleType.Administration}
        deleteItems={deleteItems}
      />
    </>
  );
};
